<script setup>
import SendTestEmailAction from '@frontJs/components/actions/SendTestEmailAction.vue';

const { tenant, emailing } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    emailing: {
        type: Object,
        required: true,
    },
});

function send(email) {
    return axios.post(
        route('front.projectManagement.modules.postSendTestEmail', {
            tenant: tenant.id,
            emailing: emailing.id,
        }),
        { email },
    );
}
</script>

<template>
    <SendTestEmailAction :send="send">
        <template #trigger>
            <slot name="trigger" />
        </template>
    </SendTestEmailAction>
</template>
